import script from "./PatientSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientSelection.vue?vue&type=script&lang=ts&setup=true"

import "./PatientSelection.vue?vue&type=style&index=0&id=30a5a8a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a5a8a6"]])

export default __exports__